import React from 'react';

import { Select } from 'antd';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import ErrorMessage from 'components/ErrorMessage';
import Input from 'components/Input';
import TitleInput from 'components/TitleInput';
import { ENUM_PASSWORD_CREATE_ERROR } from 'constants/enum';

const EnterAccountInfomation = ({ form, emailInValidJapan, listFacilities }) => {
  const { t } = useTranslation();

  return (
    <div className="w-indicators mx-auto">
      <fieldset data-testid="name">
        <TitleInput className="!mt-0" text={t('NAME_THERAPIST')} required={true} />
        <Input id="name" type="text" name="name" value={form.values.name} onChange={form.handleChange} invalid={form.errors?.name} />
        <p className={`text-sm ${form.errors.name ? 'text-danger-229' : 'text-secondary-354'}`}>
          {!form.values.name && form.errors.name && <ErrorMessage>{t('NOT_EMPTY')}</ErrorMessage>}
        </p>
      </fieldset>

      <fieldset data-testid="email">
        <TitleInput text={t('EMAIL_ADDRESS')} required={true} />
        <Input id="email" type="text" name="email" value={form.values.email} onChange={form.handleChange} invalid={form.errors?.email} />
        <p className={`text-sm ${form.errors.email || emailInValidJapan ? 'text-danger-229' : 'text-secondary-354'}`}>
          {!form.values.email && form.errors.email && <ErrorMessage>{t('NOT_EMPTY')}</ErrorMessage>}
          {form.values.email ? (
            emailInValidJapan ? (
              <ErrorMessage>{t('EMAIL_INVALID_FORMAT')}</ErrorMessage>
            ) : (
              form.errors.email && <ErrorMessage>{t('EMAIL_INVALID')}</ErrorMessage>
            )
          ) : (
            <></>
          )}
          {!form.errors.email && !emailInValidJapan && t('REQUIRED_EMAIL_TEXT')}
        </p>
      </fieldset>

      <fieldset data-testid="password">
        <TitleInput text={t('PASSWORD')} required={true} />
        <Input
          id="password"
          type="password"
          name="password"
          value={form.values.password}
          onChange={form.handleChange}
          invalid={form.errors?.password}
        />
        <div className={`text-sm ${form.errors?.password ? 'text-danger-229' : 'text-secondary-354'}`}>
          {!form.values.password && form.errors.password ? (
            <ErrorMessage>{t('NOT_EMPTY')}</ErrorMessage>
          ) : (
            <>
              {form.errors.password && (
                <ErrorMessage>
                  <div>
                    <p>{t('PASSWORD_INVALID_TEXT')}</p>
                    <p>{t('PASSWORD_INVALID_REQUIRED_TEXT')}</p>
                  </div>
                </ErrorMessage>
              )}
              {!form.errors.password && <p>{t('PASSWORD_REQUIRED_TEXT')}</p>}
              <ul className={`list-disc ${form.errors?.password ? 'ml-11' : 'ml-6'}`}>
                {(!form.errors.password || (form.errors.password && form.errors.password.includes(ENUM_PASSWORD_CREATE_ERROR.LENGTH))) && (
                  <li>{t('PASSWORD_REQUIRED_LENGTH')}</li>
                )}
                {(!form.errors.password ||
                  (form.errors.password &&
                    _.intersection(form.errors.password || [], [
                      ENUM_PASSWORD_CREATE_ERROR.HAS_LOWERCASE,
                      ENUM_PASSWORD_CREATE_ERROR.HAS_UPPERCASE,
                      ENUM_PASSWORD_CREATE_ERROR.HAS_NUMBER,
                    ]).length > 0)) && <li>{t('PASSWORD_REQUIRED')}</li>}
                {(!form.errors.password || (form.errors.password && form.errors.password.includes(ENUM_PASSWORD_CREATE_ERROR.HAS_FULL_WIDTH))) && (
                  <li>{t('PASSWORD_REQUIRED_CHARACTER')}</li>
                )}
                {(!form.errors.password ||
                  (form.errors.password &&
                    _.intersection(form.errors.password || [], [
                      ENUM_PASSWORD_CREATE_ERROR.HAS_SYMBOLS,
                      ENUM_PASSWORD_CREATE_ERROR.HAS_SYMBOLS_REQUIRED,
                    ]).length > 0)) && <li>{t('PASSWORD_REQUIRED_SYMBOL')}</li>}
              </ul>
            </>
          )}
        </div>
      </fieldset>

      <fieldset data-testid="password-confirm">
        <TitleInput text={t('CONFIRM_PASSWORD')} required={true} />
        <Input
          id="password-confirm"
          type="password"
          name="passwordConfirm"
          value={form.values.passwordConfirm}
          onChange={form.handleChange}
          invalid={form.errors?.passwordConfirm}
        />
        <p className={`text-sm ${form.errors.passwordConfirm ? 'text-danger-229' : 'text-secondary-354'}`}>
          {!form.values.passwordConfirm && form.errors.passwordConfirm && <ErrorMessage>{t('NOT_EMPTY')}</ErrorMessage>}
          {form.values.passwordConfirm && form.errors.passwordConfirm && <ErrorMessage>{t('PASSWORD_MATCHING')}</ErrorMessage>}
        </p>
      </fieldset>

      <fieldset data-testid="facilities">
        <TitleInput text={t('FACILITY_NAME')} required={true} />
        <Select
          value={form.values.facility_id || null}
          showSearch
          allowClear
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          onChange={(value) => {
            form.setFieldValue('facility_id', value);
          }}
          onClear={() => {
            form.setFieldValue('facility_id', undefined);
          }}
          options={listFacilities}
          className={(() => {
            let _class = 'w-full h-10 focus:outline-none placeholder:text-base placeholder:text-secondary-354 border border-solid px-3 py-2 bg-white text-[16px]';
            if (form.errors.facility_id) {
              _class += ' border-danger-229';
            } else {
              _class += ' border-gray-651';
            }

            return _class;
          })()}
        />
        <p className={`text-sm ${form.errors.facility_id ? 'text-danger-229' : 'text-secondary-354'}`}>
          {!form.values.facility_id && form.errors.facility_id && (
            <ErrorMessage>{t('NOT_EMPTY')}</ErrorMessage>
          )}
        </p>
      </fieldset>

      <Button
        data-testid="btn-confirm"
        onClick={form.handleSubmit}
        className={`w-60 h-9.5 mt-8 mx-auto ${Object.keys(form?.errors)?.length > 0 && 'opacity-50 cursor-not-allowed'}`}
        color="primary"
        type="button"
        text={t('GO_TO_CONFIRM')}
      />
    </div>
  );
};

export default React.memo(EnterAccountInfomation);
